export const enLearningHistory = {
  title: "What Olive Learned About You",
  info: {
    ariaLabel: "How Olive learns",
    heading: "How Olive learns",
    rows: {
      sources: {
        label: "Sources",
        value:
          "your chat turns, plus feedback and comments on chat responses and nuggets — " +
          "learned separately for each domain",
      },
      threshold: {
        label: "Threshold",
        value: "at least 10 chat interactions are needed",
      },
      frequency: {
        label: "Frequency",
        value: "insights are regenerated daily",
      },
    },
  },
  empty: "Olive hasn't learned anything about you yet — keep chatting to build up insights.",
  card: {
    basedOnInteractions: "Based on {{count}} interactions",
    moreTags: "+{{count}} more",
    viewEvidenceAriaLabel: "View evidence for {{title}}",
    overrideAriaLabel: "Override learning for {{title}}",
    ignoredBadge: "Ignored",
    allDomains: "All domains",
    confidence: {
      high: "High confidence",
      medium: "Medium confidence",
      low: "Low confidence",
    },
  },
  evidenceModal: {
    evidenceLabel: "Evidence",
    noEvidence: "No supporting evidence recorded.",
    closeAriaLabel: "Close",
  },
  overrideModal: {
    title: "Override Learning: {{title}} = {{priority}} Priority",
    currentLabel: "Current",
    reasonLabel: "Reason",
    priorityWord: "Priority",
    optionsLabel: "Override Options",
    closeAriaLabel: "Close",
    cancel: "Cancel",
    applyOverride: "Apply Override",
    options: {
      apply_based_on_confidence: "Apply based on confidence (automatic)",
      ignored: "Ignore these interactions (don't learn from them)",
      manual_priority: "Change priority manually",
      temporarily_ignored: "This was temporary disinterest (ignore recent period only)",
      always_apply: "Always show (high priority)",
    },
    priorityLabel: {
      high: "High",
      medium: "Medium",
      low: "Low",
    },
    reason: {
      manualPriority: "Manually set to {{label}}",
      alwaysApply: "Always shown by your choice",
      ignored: "Ignored by your choice",
      temporarilyIgnored: "Temporarily ignored by your choice",
      temporarilyIgnoredUntil: "Ignored by your choice until {{date}}",
    },
    errors: {
      saveFailed: "Couldn't save this override. Please try again.",
    },
  },
} as const;
